import api from "../axiosIntercepture";

export const getCategoryAPI = async () => {
    try {
        const response = await api.post('/ordermanagement/getCategory');
        return response.data?.data;
    }
    catch (err) {
        throw err?.response?.data || err;
    }
}



export const getID = async () => {
    try {
        const response = await api.post('/ordermanagement/getItemID');
        // console.log(response, "response");

        return response?.data.data;
    }
    catch (err) {
        throw err?.response?.data || err;
    }
}



export const createItemAPI = async (data) => {
    try {
        const { images, ...rest } = data;
        // console.log(data, "data");
        const fd = new FormData();

        data.images.forEach(file => {
            fd.append('files', file);
        });

        fd.append('content', JSON.stringify(rest));

        const response = await api.post('/ordermanagement/createSKuItem', fd, {
            headers: { "Content-Type": "multipart/form-data" }
        })

        return response?.data.data;

    }
    catch (err) {
        console.error(err)
    }
}



export const updateItemAPI = async (data,id) => {
    try {
        const { images, ...rest } = data;
        const fd = new FormData();

        data.images.forEach(file => {
            fd.append('files', file);
        });

        fd.append('content', JSON.stringify(rest));

        const response = await api.post(`/ordermanagement/updateSkuItem/${id}`, fd, {
            headers: { "Content-Type": "multipart/form-data" }
        })

        return response?.data.data;

    }
    catch (err) {
        console.error(err)
    }
}

export const getItemList = async (page, pageSize) => {
  try {
    const response = await api.post(
      `/ordermanagement/getSkuItem?page=${page+1}&limit=${pageSize}`
    );
    return response.data?.data;
  } catch (err) {
    throw err?.response?.data?.message;
  }
}

export const getItemListbyCode = async (data) => {
  try {
    const response = await api.post(
      `/ordermanagement/getSkuItembyCode`,data
    );
    return response.data?.data;
  } catch (err) {
    throw err?.response?.data?.message;
  }
}


export const getHsnbyCode = async (data) => {
  try {
    const response = await api.post(
      `/hsn/fetchHsnCode?hsnCode= ${data}`,
    );
    return response.data?.data;
  } catch (err) {
    throw err?.response?.data?.message;
  }
}


export const createPricingApi = async(data)=>{
    try{
        const response = await api.post('/ordermanagement/createPricing',data);

        return response?.data.data;
    }
    catch(err){
          throw err?.response?.data?.message;
    }
}

export const getItemPricingList = async (page, pageSize) => {
  try {
    const response = await api.post(
      `/ordermanagement/getPricingList?page=${page+1}&limit=${pageSize}`
    );
    return response.data;
  } catch (err) {
    throw err?.response?.data?.message;
  }
}

export const sendSkuToWms = async (data) => {
  try {
    const response = await api.post('/ordermanagement/sendSkuToWms', data);
    return response?.data;
  } catch (err) {
    throw err?.response?.data || err;
  }
}

export const updateSkuToWms = async (data) => {
  try {
    const response = await api.post('/ordermanagement/updateSkuToWms', data);
    return response?.data;
  } catch (err) {
    throw err?.response?.data || err;
  }
}

  